module.exports = __webpack_public_path__ + "static/media/danut-codrescu.13fe73a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/avatars/danut-codrescu.png
// module id = 821
// module chunks = 0